import React from 'react';
import AlertErrorIcon from 'material-ui/svg-icons/alert/error';

export default function ErrorBlock(props) {
  return (
    <div className="errorBox">
        <AlertErrorIcon color="#F44B46"/>
        {props.errorText}
    </div> 
  );

}


// WEBPACK FOOTER //
// ./src/components/ErrorBlock.js